function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Table, message, Select, Form, DatePicker, Divider, Skeleton, Statistic, Progress } from 'antd';
import Common from '../components/includes/Common';
import { CashCoin, Truck, Building } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Dashboard = function Dashboard() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataChanged = _useState2[0],
    setIsDataChanged = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    stationsOptions = _useState6[0],
    setStationsOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedStationId = _useState8[0],
    setSelectedStationId = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedStation = _useState10[0],
    setSelectedStation = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    stationsList = _useState12[0],
    setStationsList = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    dashboardData = _useState14[0],
    setDashboardData = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    providerArray = _useState16[0],
    setProviderArray = _useState16[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleStationChange = function handleStationChange(v) {
    setSelectedStationId(v);
    setIsDataChanged(true);
  };
  var providersTableCol = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "FOURNISSEUR"
    }),
    dataIndex: 'label',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "BALANCE (GNF)"
    }),
    dataIndex: 'balance',
    key: 'balance',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }];
  var getAllData = function getAllData() {
    axios.get("".concat(Common.baseApiUrl, "getdashboarddata/").concat(Common.currentStation.id, "/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setDashboardData(response.data.data);
        setProviderArray([]);
        response.data.data.providersList.forEach(function (p) {
          setProviderArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: p.id,
              label: p.label,
              balance: p.balance
            }]);
          });
        });
      } else {
        message.error({
          content: "Une erreur est survenue l'ors du chargement des donnees. " + response.data.message
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue l'ors du chargement des donnees"
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    if (Common.currentStation != 'undefined') {
      getAllData();
    }
  }, [isDataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            style: {
              background: '#FFB922'
            },
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(Statistic, {
              valueStyle: {
                fontSize: '40px',
                fontWeight: 'bold'
              },
              prefix: /*#__PURE__*/_jsx(CashCoin, {
                size: 35
              }),
              title: "SOLDE DE CAISSE",
              value: dashboardData.cashBoxBalance
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : dashboardData.tanks.map(function (t) {
              return /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("span", {
                  children: t.product.label
                }), /*#__PURE__*/_jsx(Progress, {
                  size: [300, 20],
                  strokeColor: {
                    '0%': '#C72121',
                    '100%': '#81BC6B'
                  },
                  percent: t.available_quantity / t.capacity * 100
                })]
              }, t.id);
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 2,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            style: {
              background: '#3C6388'
            },
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : dashboardData.tanks.map(function (t) {
              return /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: {
                    fontSize: '25px',
                    color: '#EEE'
                  },
                  title: /*#__PURE__*/_jsx("span", {
                    style: {
                      color: '#EEE'
                    },
                    children: t.product.label + " DISPONIBLE (LITRES)"
                  }),
                  value: t.available_quantity.toLocaleString('Fr')
                })
              }, t.id);
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 4,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            style: {
              background: '#FFD780'
            },
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(Statistic, {
              valueStyle: {
                fontSize: '30px',
                fontWeight: 'bold'
              },
              prefix: /*#__PURE__*/_jsx(CashCoin, {
                size: 25
              }),
              title: "VENTE DU MOIS (GNF)",
              value: (dashboardData.monthlySoldLiters * 12000).toLocaleString('Fr')
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            children: /*#__PURE__*/_jsx(Table, {
              bordered: true,
              columns: providersTableCol,
              dataSource: providerArray,
              loading: isDataLoading,
              size: "small",
              pagination: false
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            style: {
              background: '#001528'
            },
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(Statistic, {
              valueStyle: {
                fontSize: '25px',
                color: '#EEE'
              },
              prefix: /*#__PURE__*/_jsx(Truck, {
                size: 25
              }),
              title: /*#__PURE__*/_jsx("span", {
                style: {
                  color: '#EEE'
                },
                children: "COMMANDE EN ATTENTE DE VALIDATION"
              }),
              value: dashboardData.orderToBeValidated
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(Statistic, {
              valueStyle: {
                fontSize: '25px'
              },
              prefix: /*#__PURE__*/_jsx(Truck, {
                size: 25
              }),
              title: "COMMANDE EN ATTENTE DE LIVRAISON",
              value: dashboardData.orderPendingDelivery
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(Statistic, {
              valueStyle: {
                fontSize: '25px'
              },
              prefix: /*#__PURE__*/_jsx(CashCoin, {
                size: 25
              }),
              title: "TOTAL DEPENSES EFFECTUEES MOIS M",
              value: dashboardData.currentMonthExpenses
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "dashBox",
            children: dashboardData == null ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(Statistic, {
              valueStyle: {
                fontSize: '25px'
              },
              prefix: /*#__PURE__*/_jsx(Building, {
                size: 25
              }),
              title: "TOTAL DEPOTS BANQUE MOIS",
              value: dashboardData.currentMonthBankDeposit
            })
          })
        })]
      })]
    })
  });
};
export default Dashboard;